export enum PageTypes {
    Page = 'page',
    Navigation = 'navigation',
    ManufacturerDetail = 'productManufacturer',
    ManufacturerCategory = 'frontend.product_manufacturer.category.detail',
    NotFound = 'notFound',
    Error = 'error',
    Redirect = 'redirect',
    Blog = 'blog',
    ProductDetail = 'detail',
    ShopTheLook = 'look',
}

export enum SanitySchemaTypes {
    Page = 'page',
    Manufacturer = 'manufacturer',
}

export interface PageSeoData {
    metaTitle?: string | null;
    metaDescription?: string | null;
    metaKeywords?: string | null;
    pageTitle?: string | null;
    /** HTML rendered below the product listing (manufacturer × category pages) */
    content?: string | null;
    /** HTML rendered above the product listing (manufacturer and manufacturer × category pages) */
    topContent?: string | null;
    /** Robots directive from Shopware, e.g. `noindex,follow` for categories flagged noindex in the admin */
    robots?: string | null;
}

export interface PageData {
    type?: string;
    title?: string;
    content?: string;
    context?: any;
    redirect?: string;
    product?: any;
    seo?: PageSeoData & Record<string, any>;
    breadcrumb?: any;
}
